module.exports = kolibriCoreAppGlobal.coreVue.vuex.constants;